<!-- <div class="page">
  <div class="toolbar">
    <div><div class="eyebrow">Patient portal</div><h2>My visits, medication, test results</h2></div>
    <div style="margin-left:auto" class="toolbar"><button (click)="logout()">Logout</button></div>
  </div>

  <div class="section panel" *ngIf="me">
    <h3>{{ me.name }}</h3>
    <div class="small">{{ me.email }} | Role: {{ me.role }}</div>
  </div>

  <div class="section panel">
    <h3>Visits</h3>
    <div class="card-list">
      <div class="card-item" *ngFor="let v of visits">
        <div><b>Visit #{{ v.visit_number }}</b> <span class="small">{{ v.visit_datetime }}</span></div>
        <div class="small">Diagnosis: {{ v.diagnosis }}</div>
        <div class="small">Treatment: {{ v.treatment }}</div>
        <div class="small">Advice: {{ v.advice }}</div>
        <div class="small">Tests: {{ v.investigations }}</div>
      </div>
    </div>
  </div>
</div> -->

<div class="shell">
  <header class="topbar" style="margin-bottom: 15px;">
    <div>
      <div class="eyebrow">VisitoCare</div>
      <h1>Patient's Workspace</h1>
      <!-- <p class="subtext">Role-based editing for demographic information, vital signs, medical history, provisional diagnosis, investigations, advice, treatment, and follow-up visits.</p> -->
    </div>
    <!-- <div>Tracing: {{trace}}</div> -->
    <!-- <ul class="dropdown-list" *ngIf="vitalsList.length > 0">

            <li
                *ngFor="let vital of vitalsList"
                (click)="selectPatient(vital)">

                <strong>{{vital.patient_id}}</strong>

                {{vital.doctor_id}}

                ({{vital.visit_id}})

            </li>

        </ul> -->

    <div style="margin-left: 1cm;" class="topbar-actions">
      <!-- <div class="role-box">
        <label>Active role</label>
        <select [(ngModel)]="role" (ngModelChange)="onRoleChange()" [ngModelOptions]="{ standalone: true }">
          <option value="Doctor">Doctor</option>
          <option value="Medical Assistant">Medical Assistant</option>
          <option value="Patient">Patient</option>
        </select> 
      </div> -->
      

      <!-- <div class="patient-chip"><span>Patient ID</span><strong>{{ patient_id }}</strong></div>
      <div class="patient-chip"><span>Visit ID</span><strong>{{ visit_id }}</strong></div>
      <div class="patient-chip"><span>Current patient</span><strong>{{ state.demography.fullName || 'Not Selected' }}</strong></div> -->
      <!-- <div class="patient-chip"><span>Your Active Role</span><strong>{{ user.role }}</strong></div> -->

    </div>

    <div style="margin-left:auto" class="toolbar">
      <!-- <div class="topbar-actions">
            <div class="patient-chip"><span>Your Active Role</span><strong>{{ user.role }}</strong></div>
      </div> -->
      <!-- <button (click)="resetPatientForm()">New patient</button> -->
      <!-- <button style="margin-right: 12px;" (click)="newPatient()">{{newpatientText}}</button> -->
      <!-- <button style="margin-right: 12px;" (click)="profile()">{{email}}</button> -->
      <button style="margin-top: 12px; margin-right: 12px;" class="btn btn-primary"
        (click)="openProfile()"> <i class="fa fa-user-circle"></i> {{user.email}}
      </button>
      <button (click)="logout()">Logout</button>
      
      <!-- <div  style="margin-top: 12px;"  class="small" *ngIf="message">{{ message }}</div> -->

    </div>
  </header>

  <div class="card" style="margin-top: 5px;">
    <!-- <div class="grid grid-2"> -->
      <!-- <div>
        <label>Search patients</label>
        <input [(ngModel)]="query" placeholder="ID, name, phone, email, address">
      </div> -->
      <!-- <div style="display:flex; align-items:end">
         <div  style="width:24%;" class="search-box">
            <input type="text" class="form-control" placeholder="Search Patient..." [(ngModel)]="searchText" (input)="searchPatient()" autocomplete="off">
            <ul class="dropdown-list" *ngIf="patients.length > 0">
                <li *ngFor="let patient of patients" (click)="selectPatient(patient)">
                    <strong>{{patient.patient_code}}</strong> {{patient.full_name}} ({{patient.phone}})
                </li>
            </ul>
          </div>
      </div> -->
<div class="visit-toolbar">

  <div class="search-box">

    <input
        #searchInput
        type="text"
        class="form-control"
        
        [(ngModel)]="searchText"

        (input)="searchPatient()"

        (keydown)="handleKeyDown($event)"

        placeholder="Search Doctor"
        

        autocomplete="off">

        

    <!-- <div
        class="dropdown"

        *ngIf="filteredPatients.length">

        <div

            *ngFor="let patient of filteredPatients; let i=index"

            class="dropdown-item"

            [class.active]="i==selectedIndex"

            (click)="selectPatient(patient)"

            (mouseenter)="selectedIndex=i">

            <div class="patient-code">

                {{patient.patient_code}}

            </div>

            <div class="patient-name">

                {{patient.full_name}}

            </div>

            <div class="patient-detail">

                {{patient.sex}}

                •

                {{patient.age}} Years

                •

                {{patient.phone}}

            </div>

        </div>

    </div> -->

</div>
      <div class="patient-chip"><span>Current Doctor</span><strong>{{ state.demography.fullName || 'Not Selected' }}</strong></div>
      <div class="patient-chip"><span>Patient ID</span><strong>{{ patient_id || '0'}}</strong></div>
      <div class="patient-chip"><span>Visit ID</span><strong>{{ visit_id || '0'}}</strong></div>
      <div style="margin-left:auto" class="toolbar">
      <!-- <button (click)="resetPatientForm()">New patient</button> -->
      <button  class="eyebrow2" style="margin-right: 12px;" (click)="newPatient()">{{newpatientText}}</button>
      </div>
</div>

    <!-- Search Box -->
    <!-- <div class="search-box">

        <input
            type="text"
            class="form-control"
            placeholder="Search Patient..."
            [(ngModel)]="searchText"
            (input)="searchPatient()"
            autocomplete="off">

        <ul class="dropdown-list" *ngIf="patients.length > 0">

            <li
                *ngFor="let patient of patients" (click)="selectPatient(patient)">

                <strong>{{patient.patient_code}}</strong>

                {{patient.full_name}}

                ({{patient.phone}})

            </li>

        </ul>

    </div> -->

    <div>
    <!-- New Visit -->
     <div *ngIf="showVisitList">

      <!-- Visit Buttons -->
      <div class="visit-container" style="margin-top: 24px;">
           <button class="visit-button" [class.active]="selectedVisit===null" (click)="newVisit()"> <i class="fa fa-plus"></i>New Visit
          <div class="visit-date">(Today)</div></button>

          <button
              *ngFor="let visit of visits"
              class="visit-button"
              [class.active]="selectedVisit?.visit_id===visit.visit_id"
              (click)="selectVisit(visit)">

              <div class="visit-title">

                  Visit {{visit.visit_id}}

              </div>

              <div class="visit-date">

                  {{visit.visit_datetime | date:'dd MMM yyyy'}}

              </div>

              <!-- <div class="visit-type">

                  {{visit.doctor_id}}

              </div> -->

          </button>        

      </div>
     <div
  class="vitals-dashboard"
  *ngIf="showVitalCharts && latestVital">

  <div class="vitals-dashboard-header">

    <div>
      <h4>Vital Signs Trend</h4>

      <!-- <span>
        {{ patient_name }}
      </span> -->
    </div>

  </div>


  <div class="vitals-grid">

  <!-- 1 -->
  <div class="vital-card">
    <div class="vital-title">Blood Pressure</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="bpChartData"
        [options]="bpChartOptions">
      </canvas>
    </div>
  </div>


  <!-- 2 -->
  <div class="vital-card">
    <div class="vital-title">Heart Rate</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="heartRateChartData"
        [options]="vitalChartOptions">
      </canvas>
    </div>
  </div>


  <!-- 3 -->
  <div class="vital-card">
    <div class="vital-title">Temperature</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="temperatureChartData"
        [options]="vitalChartOptions">
      </canvas>
    </div>
  </div>


  <!-- 4 -->
  <div class="vital-card">
    <div class="vital-title">SpO₂</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="spo2ChartData"
        [options]="vitalChartOptions">
      </canvas>
    </div>
  </div>


  <!-- 5 -->
  <div class="vital-card">
    <div class="vital-title">Respiratory Rate</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="respiratoryChartData"
        [options]="vitalChartOptions">
      </canvas>
    </div>
  </div>


  <!-- 6 -->
  <div class="vital-card">
    <div class="vital-title">Weight</div>

    <div class="vital-chart">
      <canvas
        baseChart
        [type]="'line'"
        [data]="weightChartData"
        [options]="vitalChartOptions">
      </canvas>
    </div>
  </div>

</div>

</div>

      <!-- <div style="width: 100%; height: 300px;">

        

</div> -->

    </div>

</div>
      
 
    <!-- <div class="visit-toolbar">
      <button class="btn btn-success" (click)="newVisit()"> <i class="fa fa-plus"></i> New Visit </button>
    </div> -->

    
    <!-- <div class="visit-list">
        <button *ngFor="let visit of visits" class="visit-button" [class.active]="selectedVisit?.id===visit.id" (click)="selectVisit(visit)">
            Visit {{visit.visit_no}} <br> {{visit.visit_date}}
        </button>
    </div> -->

    <!-- <div class="small" style="margin-top:8px">Search is available by patient ID, name, phone, email, and address.</div> -->

    <!-- <div class="card-list section">
      <div class="card-item" *ngFor="let p of patients">
        <div><b>{{ p.full_name }}</b> <span class="small">({{ p.patient_code }})</span></div>
        <div class="small">{{ p.phone }} | {{ p.email }} | {{ p.address }}</div>
        <div class="toolbar" style="margin-top:8px">
          <button >Open / Edit</button>
          <button >Delete</button>
          <a class="link" [routerLink]="['/patients', p.id]">Detail</a>
        </div>
      </div>
    </div> -->
  </div> 

  <div class="card" style="margin-top: 5px;">

<div class="patient-grid" *ngIf="filteredPatients.length > 0">

  <div
    class="patient-card"
    *ngFor="let patient of filteredPatients; let i = index"
    [class.selected-card]="i === selectedIndex"
    (click)="selectPatient(patient)"
    (mouseenter)="selectedIndex = i">

    <div class="patient-card-header">

      <div class="patient-avatar">
        {{ patient.full_name?.charAt(0) | uppercase }}
      </div>

      <div class="patient-title">
        <div class="patient-name">
          {{ patient.full_name }}
        </div>

        <div class="patient-code">
          {{ patient.patient_code }}
        </div>
      </div>

    </div>

    <div class="patient-details">

      <div>
        <span class="label">Gender:</span>
        {{ patient.sex }}
      </div>

      <div>
        <span class="label">Age:</span>
        {{ patient.age }} Years
      </div>

      <div>
        <span class="label">Phone:</span>
        {{ patient.phone }}
      </div>

    </div>

  </div>

</div>
</div>

  <section class="layout" *ngIf="showPatient">
    <article class="card">
      <div class="card-head"><h2>Demographic information</h2>
        <span class="badge">Editable by doctor / assistant / patient</span>
      </div>
      <div class="grid-2">
        <div class="span-2"><label>Full name</label><input [(ngModel)]="state.demography.fullName" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <div><label>Age</label><input type="number" [(ngModel)]="state.demography.age" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <div><label>Sex</label><select [(ngModel)]="state.demography.sex" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')"><option value="">Select</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option></select></div>
        <div><label>Phone</label><input [(ngModel)]="state.demography.phone" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <div><label>Email</label><input [(ngModel)]="state.demography.email" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <div class="span-2"><label>Address</label><input [(ngModel)]="state.demography.address" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <div class="span-2"><label>Occupation</label><input [(ngModel)]="state.demography.occupation" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('demography')" /></div>
        <!-- <div class="span-2" style="visibility:visible;"><label>Patient ID (generated automatically)</label><input [(ngModel)]="demography.patientId" [ngModelOptions]="{ standalone: true }" disabled/></div> -->
      </div>
      <!-- <div class="button-row"><button type="button" (click)="saveDemoInfo(1)" [disabled]="!canEdit('demography')" >Save demographic information</button></div>
      <div  style="margin-top: 12px;" class="error" *ngIf="error">Message: {{ error }}</div>
      <div  style="margin-top: 12px;"  class="small" *ngIf="message">{{ message }}</div> -->

    </article>

    

    <article class="card">
      <div class="card-head"><h2>Chief complaints & medical history</h2>
        <!-- <span class="badge">Choose from list</span> -->
      </div>
      <label>Available chief complaints</label>
      <div  *ngIf="!muteInfo">
        <div class="chips">
          <button type="button" class="chip" *ngFor="let item of allComplaints" (click)="toggleComplaint(item)" [disabled]="!canEdit('history')">{{ item }}</button>
        </div>

        <div class="section-gap"></div>
        <div class="inline-form">
          <input placeholder="Add custom chief complaint" [(ngModel)]="newComplaint" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('history')" />
          <button type="button" (click)="addComplaint()" [disabled]="!canEdit('history')">Add</button>
        </div>
      

        <div *ngIf="editingComplaint >= 0" class="complaint-editor">
                <!-- <h4>Edit Complaint</h4> -->
                <!-- <label>Include Duration</label> -->
                <input style="margin-top: 20px; margin-bottom: 12px; width:50px;"
                    [(ngModel)]="complaintDuration"
                    placeholder="">
                <button style="margin-left: 5px;" (click)="saveComplaintDuration()">
                    Save
                </button>
                <button style="margin-left: 5px;" (click)="editingComplaint=-1">
                    ×
                </button>

        </div>
      </div>
      <div class="chips" *ngIf="state.chiefComplaints.length > 0" >
        <span class="chip" *ngFor="let item of state.chiefComplaints; let i = index; trackBy: trackByIndex">{{ item }} 
          <span  *ngIf="durationChiefComplaint[item]"> ({{durationChiefComplaint[item]}} days) </span>
          <!-- <button type="button" class="chip-remove" (click)="removeComplaint(i)" [disabled]="!canEdit('history')">×</button> -->
           <div >
              <button type="button" class="chip-edit" (click)="editComplaint(i)"  *ngIf="!muteInfo">✎</button>
              <button type="button" class="chip-remove" (click)="removeComplaint(i)"  *ngIf="!muteInfo">×</button>
           </div>
        </span>
      </div>
      <div class="section-gap"></div>
        <label>Available medical history items</label>
        <div  *ngIf="!muteInfo">
            <div class="chips">
              <button type="button" class="chip" *ngFor="let item of allHistory" (click)="toggleHistory(item)" [disabled]="!canEdit('history')">{{ item }}</button>
            </div>
            <div>
                <div class="section-gap"></div>
                <div class="inline-form">
                  <input placeholder="Add custom history item" [(ngModel)]="newHistory" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('history')" />
                  <button type="button" (click)="addHistory()" [disabled]="!canEdit('history')">Add</button>
              </div>
            </div>
         </div>
      <div class="chips" *ngIf="state.medicalHistory.length > 0">
        <span class="chip" *ngFor="let item of state.medicalHistory; let i = index; trackBy: trackByIndex">{{ item }} <button type="button" class="chip-remove" (click)="removeHistory(i)" [disabled]="!canEdit('history')"  *ngIf="!muteInfo">×</button></span>
      </div>
    </article>

    <article class="card">
      <div class="card-head"><h2>Vital signs</h2>
        <span class="badge">Editable by doctor / assistant</span>
      </div>

      <div class="grid-3">
        <div><label>BP systolic</label><input type="number" [(ngModel)]="state.vitals.bpSystolic" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>BP diastolic</label><input type="number" [(ngModel)]="state.vitals.bpDiastolic" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Pulse</label><input type="number" [(ngModel)]="state.vitals.pulse" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Temperature (°C)</label><input type="number" step="0.1" [(ngModel)]="state.vitals.temperature" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Respiratory rate</label><input type="number" [(ngModel)]="state.vitals.respiratoryRate" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>SpO2 (%)</label><input type="number" [(ngModel)]="state.vitals.spo2" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Weight (kg)</label><input type="number" step="0.1" [(ngModel)]="state.vitals.weight" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Height (cm)</label><input type="number" step="0.1" [(ngModel)]="state.vitals.height" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
        <div><label>Pain score (0-10)</label><input type="number" [(ngModel)]="state.vitals.painScore" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('vitals')" /></div>
      </div>
      <!-- <div class="button-row"><button type="button" (click)="saveDemoInfo(2)" [disabled]="!canEdit('vitals')"  *ngIf="!muteInfo">Save vital signs</button></div> -->
    </article>

    <article class="card wide">
      <div class="card-head"><h2>Provisional diagnosis</h2><span class="badge">Shortlisted from selected complaints, vitals, and history</span></div>
      <div *ngIf="!muteInfo">
          <div *ngIf="state.provisionalDiseases.length === 0" class="empty-box">Select complaints and history items to generate provisional disease suggestions.</div>
          <div class="diagnosis-grid" *ngIf="state.provisionalDiseases.length > 0">
            <button type="button" class="diagnosis-card" *ngFor="let disease of state.provisionalDiseases; let i = index; trackBy: trackByIndex" [class.selected]="state.selectedDiagnoses.includes(disease.name)" (click)="toggleDiagnosis(disease.name)" [disabled]="!canEdit('diagnosis')">
              <div class="diagnosis-header"><strong>{{ disease.name }}</strong><span>{{ disease.probability }}%</span></div>
              <div class="probability-bar"><div [style.width.%]="disease.probability"></div></div>
              <p>{{ disease.reason }}</p>
            </button>
          </div>
          <div class="section-gap"></div>
          <div class="inline-form">
            <input placeholder="Add custom diagnosis item" [(ngModel)]="newDiagnosis" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('diagnosis')" />
            <button type="button" (click)="addDiagnosis()" [disabled]="!canEdit('diagnosis')">Add</button>
          </div>
      </div>
      <div class="selected-box" *ngIf="state.selectedDiagnoses.length > 0">
        <strong>Selected suspected diagnoses:</strong>
        <div class="chips">
          <span class="chip" *ngFor="let d of state.selectedDiagnoses; let i = index; trackBy: trackByIndex">{{ d }} <button type="button" class="chip-remove" (click)="toggleDiagnosis(d)" [disabled]="!canEdit('diagnosis')"  *ngIf="!muteInfo">×</button></span>
        </div>
      </div>
    </article>

    <article class="card">
      <div class="card-head"><h2>Investigation plan</h2><span class="badge"  *ngIf="!muteInfo">Updates at runtime</span></div>
      <!-- <div class="inline-form">
        <input placeholder="Add investigation" [(ngModel)]="newInvestigation" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('plans')" />
        <button type="button" (click)="addInvestigation()" [disabled]="!canEdit('plans')">Add</button>
      </div>
      <ul class="plan-list">
        <li *ngFor="let item of state.investigationPlan; let i = index; trackBy: trackByIndex"><span>{{ item }}</span><button type="button" class="remove-btn" (click)="removeInvestigation(i)" [disabled]="!canEdit('plans')">Remove</button></li>
      </ul> -->
      <div  *ngIf="!muteInfo">
        <div class="chips">
          <button type="button" class="chip" *ngFor="let item of state.investigationPlan" (click)="toggleInvestigation(item)"  [disabled]="!canEdit('history')">{{ item }}</button>
        </div>

        <div class="section-gap"></div>
        <div class="inline-form">
          <input placeholder="Add custom investigation" [(ngModel)]="newInvestigation" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('history')" />
          <button type="button" (click)="addInvestigation()" [disabled]="!canEdit('history')">Add</button>
        </div>
      

        <div *ngIf="editingInvestigation >= 0" class="complaint-editor">
                <!-- <h4>Edit Complaint</h4>  -->
                <label>Include Result</label>
                <input style="margin-top: 20px; margin-bottom: 12px; width:50px;"
                    [(ngModel)]="investigationResult"
                    placeholder="">
                <button style="margin-left: 5px;" (click)="saveInvestigationResult()">
                    Save
                </button>
                <button style="margin-left: 5px;" (click)="editingInvestigation=-1">
                    ×
                </button>

        </div>
    </div>
      <div class="chips" *ngIf="selectedInvestigations.length > 0" >
        <span class="chip" *ngFor="let item of selectedInvestigations; let i = index; trackBy: trackByIndex">{{ item }} 
           <span  *ngIf="resultOfInvestigations[item]"> ({{resultOfInvestigations[item]}}) </span>
          <!-- <button type="button" class="chip-remove" (click)="removeInvestigation(i)" [disabled]="!canEdit('history')">×</button> -->
           <div >
              <button type="button" class="chip-edit" (click)="editInvestigation(i)"  *ngIf="!muteInfo">✎</button>
              <button type="button" class="chip-remove" (click)="removeInvestigation(item)"  *ngIf="!muteInfo">×</button>
           </div>
        </span>
      </div>

    </article>

    <article class="card">
      <div class="card-head"><h2>Advice</h2><span class="badge"  *ngIf="!muteInfo">Updates at runtime</span></div>
      <div class="inline-form"  *ngIf="!muteInfo">
        <input placeholder="Add advice" [(ngModel)]="newAdvice" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('plans')" />
        <button type="button" (click)="addAdvice()" [disabled]="!canEdit('plans')">Add</button>
      </div>
      <ul class="plan-list">
        <li *ngFor="let item of state.advicePlan; let i = index; trackBy: trackByIndex"><span>{{ item }}</span><button type="button" class="remove-btn" (click)="removeAdvice(i)" [disabled]="!canEdit('plans')"  *ngIf="!muteInfo">Remove</button></li>
      </ul>
    </article>

    <article class="card">
      <div class="card-head"><h2>Treatment plan</h2><span class="badge"  *ngIf="!muteInfo">Updates at runtime</span></div>
      <div class="inline-form"  *ngIf="!muteInfo">
        <input placeholder="Add treatment item" [(ngModel)]="newTreatment" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('plans')" />
        <button type="button" (click)="addTreatment()" [disabled]="!canEdit('plans')">Add</button>
      </div>
      <ul class="plan-list">
        <li *ngFor="let item of state.treatmentPlan; let i = index; trackBy: trackByIndex"><span>{{ item }}</span><button type="button" class="remove-btn" (click)="removeTreatment(i)" [disabled]="!canEdit('plans')"  *ngIf="!muteInfo">Remove</button></li>
      </ul>
    </article>

    <article class="card wide">
      <div class="card-head"><h2>Follow-up</h2><span class="badge">Doctor schedules next visit</span></div>
      <div class="">
        <!-- <div><label>Next visit date</label><input type="date" [(ngModel)]="followUpDate" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('followup')" /></div> -->
        <div><label>Follow-up note</label><input [(ngModel)]="followUpNote" [ngModelOptions]="{ standalone: true }" [disabled]="!canEdit('followup')" /></div>
      </div>
      <!-- <div class="upload-box">
        <label>Attach investigation report files (optional)</label>
        <input type="file" multiple (change)="onReportsSelected($event)" [disabled]="!canEdit('followup')" />
        <div class="chips" *ngIf="uploadedReportNames.length > 0"><span class="chip" *ngFor="let file of uploadedReportNames">{{ file }}</span></div>
      </div> -->
      <!-- <div class="button-row"><button type="button" (click)="saveFollowUp()" [disabled]="!canEdit('followup')">Save follow-up visit</button></div> -->
      
      <div class="button-row"><button type="button" (click)="saveDemoInfo(3)" [disabled]="!canEdit('followup')"  *ngIf="!muteInfo">Save Visit Info</button></div>
      <div  style="margin-top: 12px;" class="error" *ngIf="error">Message: {{ error }}</div>
      <div  style="margin-top: 12px;"  class="small" *ngIf="message">{{ message }}</div>

      <div class="button-row"><button type="button" (click)="generatePrescription()">Generate Prescription</button></div>

      <!-- <div class="report-box">
        <h3>Investigation reports in patient profile</h3>
        <div class="chips"><span class="chip" *ngFor="let file of state.investigationReports; let i = index; trackBy: trackByIndex">{{ file }}</span></div>
      </div> -->
    </article>

    <!-- <article class="card wide">
      <div class="card-head"><h2>Follow-up timeline</h2><span class="badge">Visit history</span></div>
      <div class="visit-list" *ngIf="state.visits.length > 0; else noVisits">
        <div class="visit-card" *ngFor="let visit of state.visits; let i = index; trackBy: trackByIndex">
          <div class="visit-head"><strong>{{ visit.date }}</strong><span>#{{ visit.id }}</span></div>
          <p>{{ visit.note || 'No follow-up note provided.' }}</p>
          <div class="chips" *ngIf="visit.reports.length > 0"><span class="chip" *ngFor="let report of visit.reports">{{ report }}</span></div>
        </div>
      </div>
      <ng-template #noVisits><div class="empty-box">No follow-up visits have been scheduled yet.</div></ng-template>
    </article> -->

    <!-- <article class="card wide">
      <div class="card-head"><h2>Audit trail</h2><span class="badge">Change history</span></div>
      <div class="audit-list" *ngIf="state.audits.length > 0; else noAudit">
        <div class="audit-card" *ngFor="let audit of state.audits; let i = index; trackBy: trackByIndex">
          <div class="visit-head"><strong>{{ audit.action }}</strong><span>{{ audit.at }}</span></div>
          <p><b>By:</b> {{ audit.by }} &nbsp; | &nbsp; {{ audit.detail }}</p>
        </div>
      </div>
      <ng-template #noAudit><div class="empty-box">No audit entries yet.</div></ng-template>
    </article> -->
  </section>
</div>

<div class="modal-overlay" *ngIf="showProfile">
<div class="profile-window" >

  <!-- Header -->
  <div class="profile-header">
    <div>
      <h2>Doctor's Profile</h2>
      <!-- <span>Manage your professional and consultation information</span> -->
    </div>

    <button
      type="button"
      class="close-profile"
      (click)="closeProfile()">
      &times;
    </button>
  </div>


  <!-- Body -->
  <div class="profile-body">

    <!-- Personal / Professional -->
    <div class="profile-section-title">
      Professional Information
    </div>

    <div class="profile-grid">

      <!-- Full Name -->
      <div class="form-group">
        <label>Full Name</label>

        <input
          type="text"
          class="form-control"
          [(ngModel)]="doctor.full_name">
      </div>


      <!-- Specialization -->
      <div class="form-group">
        <label>Specialization</label>

        <input
          type="text"
          class="form-control"
          [(ngModel)]="doctor.specialization">
      </div>


      <!-- Degree -->
      <div class="form-group">
        <label>Degree / Qualification</label>

        <input
         type="text"
          class="form-control"
          [(ngModel)]="doctor.qualification">
      </div>


      <!-- Medical College -->
      <div class="form-group">
        <label>Medical College</label>

        <input
          type="text"
          class="form-control"
          [(ngModel)]="doctor.hospital">
      </div>

    </div>


    <!-- Clinic Information -->
    <div class="profile-section-title section-spacing">
      Clinic Information
    </div>

    <div class="profile-grid">

      <!-- Clinic -->
      <div class="form-group">
        <label>Clinic Name / Current Job</label>

        <input
          type="text"
          class="form-control"
          [(ngModel)]="doctor.clinic">
      </div>


      <!-- Consultation -->
      <div class="form-group">
        <label>Consultation Time</label>

        <input
          type="text"
          class="form-control"
          placeholder="e.g. 5:00 PM - 9:00 PM"
          [(ngModel)]="doctor.consultation_time">
      </div>


      <!-- Address -->
      <div class="form-group full-width">
        <label>Clinic Address</label>
        <input
           type="text"
            class="form-control"
            [(ngModel)]="doctor.chamber_address">
        
        <!-- <textarea
          class="form-control"
          rows="2"
          [(ngModel)]="doctor.chamber_address">
        </textarea> -->
      </div>

    </div>

  </div>


  <!-- Footer -->
  <div class="profile-footer">
    <span style="margin-right: 20px;">{{profileSavedText}}</span>
    <button
      type="button"
      class="btn btn-success"
      (click)="saveProfile()">
      Save Changes
    </button>

    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeProfile()">
      Cancel
    </button>



  </div>

</div>
</div>
<!-- <div class="modal-overlay" *ngIf="showProfile">

    <div class="profile-window">

        <div class="profile-header">

            <h3>Doctor's Profile</h3>

            <button class="close" (click)="closeProfile()">×</button>

        </div>

        <div class="profile-body">

            <label>Full Name</label> <input class="form-control" [(ngModel)]="doctor.full_name">

            <label>Degree </label> <textarea class="form-control" [(ngModel)]="doctor.qualification"></textarea>

            <label>Specialization</label> <input class="form-control" [(ngModel)]="doctor.specialization">

            <label>Medical College (Degree Obtained from) </label> <input class="form-control" [(ngModel)]="doctor.hospital">

            <label>Clinic Name (Current Job)</label> <input class="form-control" [(ngModel)]="doctor.clinic">

            <label>Clinic Address</label> <textarea class="form-control" [(ngModel)]="doctor.chamber_address"></textarea>

            <label>Consultation Time</label> <input class="form-control"  [(ngModel)]="doctor.consultation_time">

        </div>

        <div class="profile-footer">

            <button style="margin-right: 12px;" class="btn btn-success" (click)="saveProfile()"> Save </button>

            <button class="btn btn-secondary" (click)="closeProfile()">Cancel</button>

        </div>

    </div>

</div> -->

